import { create } from "zustand";

export enum CONTENT_TEXT_ENUM {
    IMAGES_NUMBER_EXCEEDED = "Es können maximal 20 Bilder hochgeladen werden.",
    COMBINED_MEDIA_UPLOADED = "Videos können nicht parallel zu Bildern hochgeladen werden.",
    VIDEOS_NUMBER_EXCEEDED = "Es kann maximal 1 Video hochgeladen werden.",
    IMAGE_SIZE_EXCEEDED = "Die maximale Dateigröße von 20 MB wurde für ein oder mehrere Bilder überschritten.",
    VIDEO_SIZE_EXCEEDED = "Die maximale Dateigröße von 50 MB wurde für dein Video überschritten.",
    BATCH_SIZE_EXCEEDED = "Die maximale Dateigröße von 50 MB für deinen Upload wurde überschritten.",
    INVALID_MEDIA_TYPE = "Dieses Datei-Format wird nicht unterstützt.",
}

interface InvalidMediaUploadSlice {
    contentText: CONTENT_TEXT_ENUM | "";
    isOpen: boolean;
    setIsOpen: (value: boolean, mode?: CONTENT_TEXT_ENUM | "") => void;
}

export const useInvalidMediaUploadModalState =
    create<InvalidMediaUploadSlice>()((set) => ({
        isOpen: false,
        contentText: "",
        setIsOpen: (newValue: boolean, newContentText) =>
            set((state) => ({
                isOpen: newValue,
                contentText: newContentText ?? state.contentText,
            })),
    }));
